import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { useDroppable } from '@dnd-kit/core'
import Divider from '@material-ui/core/Divider'
import { makeStyles, Theme } from '@material-ui/core/styles'
import React from 'react'
import { DragDropAreaContext } from './DragDropAreaContext'

const useStyles = makeStyles((theme: Theme) => ({
    divContainer: {
        height: pxToRem(5),
        backgroundColor: '#56a1f8',
    },
}))
export interface DroppableProps {
    id: string
    index: number
    containerId: string
    disabled: boolean
    level: number
    isNestingDisabled: boolean
}

export const DroppableSpot: React.FC<DroppableProps> = ({
    id,
    children,
    index,
    containerId,
    disabled = false,
    level,
    isNestingDisabled,
}) => {
    const classes = useStyles()
    const { isRegroup } = React.useContext(DragDropAreaContext)

    const acceptedType = React.useMemo(
        () =>
            containerId?.toLowerCase().includes('dragdroparea')
                ? 'article'
                : 'content',
        [containerId]
    )
    const { isOver, setNodeRef } = useDroppable({
        id: id,
        data: {
            sortable: {
                index,
                containerId,
                type: containerId?.toLowerCase().includes('dragdroparea')
                    ? 'article'
                    : 'content',
                disabled: disabled,
                isRegroup: isRegroup && !isNestingDisabled,
                level,
            },
            accepts: [acceptedType],
        },
        disabled: disabled,
    })

    return (
        <div ref={setNodeRef} data-testid="droppablespot">
            {isOver && !disabled && !isRegroup && (
                <Divider
                    className={classes.divContainer}
                    data-testid="droppableIndicator"
                />
            )}
            {isOver && !disabled && isRegroup && !isNestingDisabled && (
                <Divider
                    variant="inset"
                    className={classes.divContainer}
                    data-testid="nestedDroppableIndicator"
                />
            )}
            {children}
        </div>
    )
}
